import { render, staticRenderFns } from "./AssessmentWizardOverlay.vue?vue&type=template&id=2bdb82a9&scoped=true"
import script from "./AssessmentWizardOverlay.vue?vue&type=script&lang=js"
export * from "./AssessmentWizardOverlay.vue?vue&type=script&lang=js"
import style0 from "./AssessmentWizardOverlay.vue?vue&type=style&index=0&id=2bdb82a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb82a9",
  null
  
)

export default component.exports